// src/data/jobs/index.ts

import { jobsDataDE } from "./jobsData.de";
import { jobsDataUA } from "./jobsData.ua";
import { getSiteConfig } from "@/config/siteConfigs";

export const getJobsData = () => {
  const siteConfig = getSiteConfig();

  switch (siteConfig.language) {
    case "de":
      return jobsDataDE;
    case "ua":
      return jobsDataUA;
    default:
      return jobsDataDE;
  }
};
